import { supabase } from '../supabaseClient'
import { ga02CumplePorDocumentos, hoyISO } from './sso-documentos'
import { decisionGa02 } from './sync-estados'

// GA-02 (Reglamento de Higiene y Seguridad) se cumple subiendo el RHS aprobado
// como documento externo en Documentos SSO (bloque 5, B3: el generador del RHS
// se quitó porque el Ministerio cambia el formato). Reemplaza al sync por
// risso_documents; los estados que dejó ese sync (auto_source 'risso') se
// recalculan con esta regla.

export async function syncGa02Compliance(companyId: string): Promise<void> {
  if (!companyId) return

  const { data: docs, error: docsErr } = await supabase
    .from('sso_documents')
    .select('file_url, is_current, expiry_date')
    .eq('company_id', companyId)
    .eq('checklist_item_id', 'GA-02')
    .eq('is_current', true)

  if (docsErr) return

  const { data: existing, error: selectErr } = await supabase
    .from('checklist_item_estados')
    .select('item_id, estado, auto_source')
    .eq('company_id', companyId)
    .eq('item_id', 'GA-02')
    .maybeSingle()

  if (selectErr) return

  const cumple = ga02CumplePorDocumentos(docs ?? [], hoyISO())
  // Bloque 6, D: manda el módulo (sync-estados.ts). Con datos = hay algún GA-02 vigente
  // (aunque esté vencido o lo haya dejado el generador del RHS). Nunca pisa un "No aplica".
  const nuevo = decisionGa02(existing, cumple, (docs ?? []).length > 0)
  if (!nuevo) return

  await supabase.from('checklist_item_estados').upsert(
    {
      company_id: companyId,
      item_id: 'GA-02',
      estado: nuevo,
      auto_source: 'documentos',
      updated_at: new Date().toISOString(),
    },
    { onConflict: 'company_id,item_id' }
  )
}
